
import Script from "next/script";
import { logger } from '@/lib/logger';

const WhatConverts = () => {
  return (
    <>
      <Script id="whatconverts-init" strategy="lazyOnload">
        {`var $wc_leads = {};
        var $wc_load = function(a){return JSON.parse(JSON.stringify(a))};
        $wc_leads.doc = {
          url: $wc_load(document.URL),
          ref: $wc_load(document.referrer),
          search: $wc_load(location.search),
          hash: $wc_load(location.hash)
        };`}
      </Script>
      <Script
        id="whatconverts-main"
        strategy="lazyOnload"
        src="https://s.ksrndkehqnwntyxlhgto.com/111092.js"
        onLoad={() => logger.log("[WhatConverts] Script loaded successfully")}
        onError={(e) => logger.error("[WhatConverts] Failed to load script:", e)}
      />
    </>
  );
};

export default WhatConverts;